import React, { useContext, useRef, useState } from "react";
import { Link } from "gatsby";
import { AppContext } from "~context/AppContext";
import { DocumentContext } from "~context/DocumentContext";
import FacebookIcon from "~components/svg/FacebookIcon";
import InstagramIcon from "~components/svg/InstagramIcon";

const Footer = () => {
  const { pathname, notificationActive, setTermsLink } = useContext(AppContext);
  const { device } = useContext(DocumentContext);

  const submitRef = useRef();

  const [email, setEmail] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  //

  const submitProxy = () => {
    if (!submitRef?.current) {
      return;
    }

    submitRef.current.click();
  };

  const onSubmit = e => {
    e.preventDefault();

    if (
      typeof window !== `undefined` &&
      window.location.href.includes(`localhost:8000`)
    ) {
      setSubmitting(true);

      setTimeout(() => {
        setSubmitting(false);
        setSubmitted(true);
      }, 3000);

      return false;
    }

    if (
      submitting ||
      submitted ||
      !process.env.GATSBY_NETLIFY_FUNCTIONS ||
      !process.env.GATSBY_MAILCHIMP_API_KEY ||
      !process.env.GATSBY_MAILCHIMP_LIST_ID
    ) {
      return false;
    }

    setSubmitting(true);

    const mailchimpData = {
      email,
      list_id: process.env.GATSBY_MAILCHIMP_LIST_ID
    };

    fetch(`${process.env.GATSBY_NETLIFY_FUNCTIONS}/mailchimp`, {
      body: JSON.stringify(mailchimpData),
      method: `POST`
    })
      .then(() => {
        setSubmitting(false);
        setSubmitted(true);
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error(error);
      });

    return false;
  };

  //

  let buttonText = `Sign up!`;

  if (submitting) {
    buttonText = `Submitting...`;
  } else if (submitted) {
    buttonText = `Thanks!`;
  }

  //

  return (
    <footer
      className={`${
        notificationActive ? `notification-active` : ``
      } footer w-full relative z-20 block pt-10 pb-4 md:pb-8 bg-clay`}
    >
      <div className="grid">
        <div className="grid-end-12 md:grid-end-4 md:pr-12 mb-4">
          <h3 className="mb-5 f4">Join the family</h3>

          <form
            className="footer__sign-up w-full relative block"
            onSubmit={onSubmit}
          >
            <input
              ref={submitRef}
              className="w-0 h-0 hidden opacity-0 pointer-events-none"
              type="submit"
            />

            <div className="w-full md:h-10 relative md:flex">
              <input
                className="w-full h-12 md:h-full mb-2 md:mb-0 px-2 bg-white b2 text-black"
                onChange={e => setEmail(e.currentTarget.value)}
                placeholder="Email"
                type="email"
              />

              <button
                type="button"
                className={`footer__sign-up__button w-full md:w-32 h-12 md:h-full ${
                  submitting || submitted ? `pointer-events-none` : ``
                } bg-orange text-white`}
                onClick={submitProxy}
              >
                <span className="b2">{buttonText}</span>
              </button>
            </div>
          </form>

          <div className="w-full relative flex mt-6">
            <a
              href="https://www.instagram.com/joeyscandizzosalon"
              rel="noopener noreferrer"
              target="_blank"
              className={`${
                device === `desktop` ? `mr-v2` : `mr-6`
              } h-6 relative block hover-underline b2`}
            >
              <InstagramIcon className="h-full" color="black" />
            </a>

            <a
              href="https://www.facebook.com/JoeyScandizzoSalon/"
              rel="noopener noreferrer"
              target="_blank"
              className="h-6 relative block hover-underline b2"
            >
              <FacebookIcon className="h-full" color="black" />
            </a>
          </div>
        </div>

        <div className="grid-end-12 md:grid-end-2 mt-8 md:mt-0">
          <h3 className="mb-5 f4">Shopping</h3>

          <ul>
            <li className="mb-4 b2">
              <Link
                to="/collections/gift-cards-&amp;-vouchers"
                className="hover-underline"
              >
                Gift Cards
              </Link>
            </li>

            <li className="mb-4 b2">
              <Link to="/collections/" className="hover-underline">
                Shop All
              </Link>
            </li>
          </ul>
        </div>

        <div className="grid-end-12 md:grid-end-2 mt-8 md:mt-0">
          <h3 className="mb-5 f4">Nitty Gritty</h3>

          <ul>
            <li className="mb-4 b2">
              {(pathname === `/terms` && (
                <button type="button" onClick={() => setTermsLink(`returns`)}>
                  Returns &amp; Refunds
                </button>
              )) || (
                <Link
                  to="/terms"
                  className="hover-underline"
                  onClick={() => setTermsLink(`returns`)}
                >
                  Returns &amp; Refunds
                </Link>
              )}
            </li>

            <li className="mb-4 b2">
              {(pathname === `/terms` && (
                <button type="button" onClick={() => setTermsLink(`shipping`)}>
                  Shipping
                </button>
              )) || (
                <Link
                  to="/terms"
                  className="hover-underline"
                  onClick={() => setTermsLink(`shipping`)}
                >
                  Shipping
                </Link>
              )}
            </li>

            <li className="mb-4 b2">
              {(pathname === `/terms` && (
                <button type="button" onClick={() => setTermsLink(`privacy`)}>
                  Privacy Policy
                </button>
              )) || (
                <Link
                  to="/terms"
                  className="hover-underline"
                  onClick={() => setTermsLink(`privacy`)}
                >
                  Privacy Policy
                </Link>
              )}
            </li>

            <li className="mb-4 b2">
              <Link to="/terms" className="hover-underline">
                Terms Of Use
              </Link>
            </li>
          </ul>
        </div>

        <div className="grid-end-12 md:grid-end-4 mt-8 md:mt-0">
          <h3 className="mb-5 f4">Contact us</h3>

          <p className="mb-4 b2">Book an Appointment:</p>
          <p className="mb-4 ml-8 b2">
            Call:{` `}
            <a href="tel:+61398277503" className="hover-underline">
              03 9827 7503
            </a>
          </p>

          <p className="mb-4 ml-8 b2">
            Email:{` `}
            <a
              href="mailto:info@joeyscandizzo.com.au"
              className="hover-underline"
            >
              info@joeyscandizzo.com.au
            </a>
          </p>

          <p className="b2">
            <a
              href="https://www.google.com/maps/place/Joey+Scandizzo+Salon/@-37.8392794,144.9926843,17z/data=!4m5!3m4!1s0x0:0x1052383865a53bbd!8m2!3d-37.8392794!4d144.9926843"
              className="hover-underline"
              rel="noopener noreferrer"
              target="_blank"
            >
              168/172 Toorak Rd, South Yarra VIC 3141
            </a>
          </p>
        </div>

        <div className="grid-end-12 mt-20 md:mt-6 text-center md:text-left">
          <p className={`${device === `desktop` ? `b2` : `caption`}`}>
            © 2021 Joey Scandizzo Salon Pty Ltd
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
